<template>
  <div>
    <!-- 新增按钮 -->
    <Button type="primary" @click="openAddModal">新增</Button>

    <Input
      v-model="searchId"
      placeholder="输入商品ID"
      style="width: 200px; margin-right: 10px"
    />
    <Input
      v-model="searchName"
      placeholder="输入商品名称"
      style="width: 200px; margin-right: 10px"
    />
    <Select
      v-model="searchType"
      placeholder="请选择商品分类"
      style="width: 200px; margin-right: 10px"
    >
      <Option value="">未选择</Option>
      <Option
        v-for="item in goodstypeOptions"
        :value="item.value"
        :key="item.value"
        >{{ item.label }}</Option
      >
    </Select>
    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="10"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
    <!-- 新增商品的模态框 -->
    <Modal v-model="modal1" width="360">
      <div style="text-align: center">
        <Form
          :label-width="120"
          ref="formData"
          :model="formData"
          :rules="rules"
        >
          <!-- 商品名称 -->
          <FormItem label="商品名称" prop="goodsname">
            <Input
              placeholder="请输入商品名称"
              v-model="formData.goodsname"
            ></Input>
          </FormItem>

          <!-- 商品市场价 -->
          <FormItem label="商品市场价" prop="marketp">
            <Input
              placeholder="请输入商品市场价"
              v-model="formData.marketp"
            ></Input>
          </FormItem>

          <!-- 商品成本价 -->
          <FormItem label="商品成本价" prop="cost">
            <Input
              placeholder="请输入商品成本价"
              v-model="formData.cost"
            ></Input>
          </FormItem>

          <!-- 分解成金币 -->
          <FormItem label="分解成金币" prop="coinnum">
            <Input
              placeholder="请输入分解成金币的数量"
              v-model="formData.coinnum"
            ></Input>
          </FormItem>

          <!-- 分解成能量 -->
          <FormItem label="分解成能量" prop="integralnum">
            <Input
              placeholder="请输入分解成能量的数量"
              v-model="formData.integralnum"
            ></Input>
          </FormItem>

          <!-- 商品封面图上传 -->
          <FormItem label="上传商品封面图" prop="goodsimg">
            <single-upload
              title="上传商品封面图"
              :old-url="formData.oldUrl"
              @update:image="updateimage1"
            />
          </FormItem>

          <!-- 商品详情图上传 -->
          <FormItem label="上传商品详情图" prop="goodsimg2">
            <single-upload
              title="上传商品详情图"
              :old-url="formData.oldUrl2"
              @update:image="updateimage2"
            />
          </FormItem>
          <FormItem label="是否允许发货">
            <RadioGroup v-model.number="formData.issend">
              <Radio :label="0">允许</Radio>
              <Radio :label="1">禁止</Radio>
            </RadioGroup>
          </FormItem>

          <!-- 商品分类 -->
          <FormItem label="商品分类" prop="goodstype">
            <Select v-model="formData.goodstype" placeholder="请选择商品分类">
              <Option
                v-for="item in goodstypeOptions"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Form>
      </div>

      <div slot="footer">
        <Button type="primary" @click="handleSubmit">提交</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modal2" title="修改商品数量" width="300">
      <div>
        <Input
          v-model="newGoodsNum"
          placeholder="请输入商品数量"
          :min="1"
          style="width: 200px"
          @on-input="validatePositiveInteger"
        /><Input
          v-model="beizhu"
          placeholder="请输入修改备注"
          style="width: 200px"
        />
      </div>
      <div slot="footer">
        <Button @click="submitGoodsNum">确认修改</Button>
        <Button @click="cancelGoodsNum">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import SingleUpload from "@/components/Upload/singleUpload";
import {
  cmsAddgoods,
  cmsSelgoods,
  cmsUpdategoods,
  cmsUpdateGoodsNum,
} from "../../api/product";

export default {
  components: { SingleUpload },
  data() {
    return {
      goodstypeOptions: this.$goodsTypeOptions,
      modal1: false,
      modal2: false,
      loading: false,
      clickgoodsid: "",
      newGoodsNum: "",
      beizhu: "",
      isEdit: false,
      formData: {
        oldUrl: "",
        oldUrl2: "",
        goodsname: "", // 商品名称
        marketp: "", // 商品市场价
        cost: "", // 商品成本价
        coinnum: "", // 分解成金币
        integralnum: "", // 分解成能量
        goodsimg: "", // 商品封面图
        goodsimg2: "", // 商品详情图
        goodstype: "", // 商品分类
        issend: 0,
      },
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "商品id",
          key: "id",
        },
        {
          title: "商品名称",
          key: "goodsname",
        },
        {
          title: "市场价",
          key: "marketp",
        },
        {
          title: "成本价",
          key: "cost",
        },
        {
          title: "封面图片",

          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: process.env.OSS + params.row.goodsimg,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },

          // key: "image",
        },
        {
          title: "商品分类",
          key: "goodstype",
        },
        {
          title: "商品数量",
          key: "goodsnum",
        },
        {
          title: "分解币数",
          key: "coinnum",
        },
        {
          title: "分解能量数",
          key: "integralnum",
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickgoodsid = params.row.id;
                      this.openEditModal(params.row); // 传入当前行的商品信息
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.clickgoodsid = params.row.id;
                      this.modal2 = true;
                    },
                  },
                },
                "修改数量"
              ),
            ]);
          },
        },
      ],
      searchId: "",
      searchName: "",
      searchType: "",
      current: 1,
      total: 0,
      // 校验规则
      rules: {
        goodsname: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
        ],
        marketp: [
          { required: true, message: "请输入商品市场价", trigger: "blur" },
          {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: "市场价最多两位小数",
            trigger: "blur",
          },
        ],
        cost: [
          { required: true, message: "请输入商品成本价", trigger: "blur" },
          {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: "成本价最多两位小数",
            trigger: "blur",
          },
        ],
        coinnum: [
          {
            required: true,
            message: "请输入分解成金币的数量",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入分解成金币的数量"));
              } else {
                if (/^[0-9]+$/.test(value)) {
                  callback(); // 验证通过
                } else {
                  callback(new Error("金币数量必须是正整数"));
                }
              }
            },
          },
        ],
        integralnum: [
          {
            required: true,
            message: "请输入分解成能量的数量",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入分解成能量的数量"));
              } else {
                if (/^[0-9]+$/.test(value)) {
                  callback(); // 验证通过
                } else {
                  callback(new Error("能量数量必须是正整数"));
                }
              }
            },
          },
        ],
        goodsimg: [
          { required: true, message: "请上传商品封面图", trigger: "change" },
        ],
        goodstype: [
          { required: true, message: "请选择商品分类", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    // 提交表单数据
    handleSubmit() {
      console.log(this.formData);
      // 表单校验
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.isEdit) {
            const formData = this.formData;
            formData.id = this.clickgoodsid;
            cmsUpdategoods(formData)
              .then((response) => {
                this.loading = false;
                this.modal1 = false; // 表单提交成功后关闭弹窗
                this.$Message.success("商品修改成功！");
                this.queryGoods(); // 刷新商品列表
              })
              .catch((error) => {
                this.loading = false;
                this.$Message.error("商品新增失败！");
                console.error(error);
              });
          } else {
            const formData = this.formData;
            cmsAddgoods(formData)
              .then((response) => {
                this.loading = false;
                this.modal1 = false; // 表单提交成功后关闭弹窗
                this.$Message.success("商品新增成功！");
                this.queryGoods(); // 刷新商品列表
              })
              .catch((error) => {
                this.loading = false;
                this.$Message.error("商品新增失败！");
                console.error(error);
              });
          }
        } else {
          this.$Message.error("请填写完整的商品信息");
          return false;
        }
      });
    },
    // 取消操作
    cancel() {
      this.modal1 = false;
    },
    // 更新封面图
    updateimage1(imageUrl) {
      this.formData.goodsimg = imageUrl;
      // 从图片URL中提取文件名
      const fileName = imageUrl.split('/').pop(); // 获取URL最后一部分作为文件名
      if (fileName) {
        // 去除文件扩展名
        const nameWithoutExt = fileName.replace(/\.[^/.]+$/, "");
        // 如果商品名称为空，则自动填充
        if (!this.formData.goodsname) {
          this.formData.goodsname = nameWithoutExt;
        }
      }
    },
    // 更新详情图
    updateimage2(imageUrl) {
      this.formData.goodsimg2 = imageUrl;
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsSelgoods(params)
        .then((response) => {
          // 确保数据中的issend字段是数字类型
          this.data9 = response.data.rows.map(item => {
            return {
              ...item,
              issend: parseInt(item.issend)
            };
          }); // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // 验证输入的是否为正整数
    validatePositiveInteger(value) {
      if (value < 1 || !Number.isInteger(+value)) {
        this.$Message.error("请输入一个正整数");
        this.newGoodsNum = "";
      }
    },
    // 查询商品
    queryGoods() {
      const params = {
        id: this.searchId || undefined,
        goodsname: this.searchName || undefined,
        goodstype: this.searchType || undefined,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },
    // 确认修改商品数量
    submitGoodsNum() {
      if (
        this.newGoodsNum &&
        Number.isInteger(+this.newGoodsNum) &&
        +this.newGoodsNum > 0
      ) {
        cmsUpdateGoodsNum({
          id: this.clickgoodsid,
          beizhu: this.beizhu,
          goodsnum: this.newGoodsNum,
        }) // 更新商品数量 API
          .then((response) => {
            this.$Message.success("商品数量更新成功！");
            this.modal2 = false; // 关闭模态框
            this.queryGoods(); // 刷新查询结果
          })
          .catch((error) => {
            this.$Message.error("商品数量更新失败！");
            console.error(error);
          });
      } else {
        this.$Message.error("请输入有效的商品数量");
      }
    },
    // 取消修改商品数量
    cancelGoodsNum() {
      this.modal2 = false;
    },
    openAddModal() {
      this.isEdit = false; // 设置为新增操作
      this.resetFormData(); // 重置表单
      this.modal1 = true; // 打开弹窗
    },
    resetFormData() {
      // 重置表单数据
      this.formData = {
        goodsname: "",
        marketp: "",
        cost: "",
        coinnum: "",
        integralnum: "",
        goodsimg: "",
        goodsimg2: "",
        goodstype: "",
        issend: 0,
      };
    },
    openEditModal(goods) {
      this.isEdit = true; // 设置为编辑操作
      this.formData = { ...goods }; // 填充表单数据，假设 `goods` 包含所需的商品信息
      // 确保issend是整数类型
      this.formData.issend = parseInt(this.formData.issend);
      console.log(this.formData.oldUrl + "===" + goods.goodsimg);
      this.formData.oldUrl = goods.goodsimg; // 将图片 URL 赋值给 formData 中的 oldUrl
      this.formData.oldUrl2 = goods.goodsimg2;
      this.modal1 = true; // 打开弹窗
    },
  },
};
</script>
